import API from 'utils/api';
import { onError } from 'utils/handlers';

export const URIdestinoPresupuestal = 'catalogos/destino-presupuestal/';
export const URIconfiguracionesDeSegmentosPresupuestales = 'configuraciones/configuraciones-de-segmentos-presupuestales/';

/**
 * GET Obtiene Lista de Registros de Una Uri
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const obtenerRegistrosDe = async (uri, params) => {
  try {
    const response = await API.get(uri, { params });
    return response.data;
    // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};
